import { Action } from "@ngrx/store";
import { ReduxAction } from "./redux.action";
import { PatientTestResultsModel } from '../models/patient-test-results.model';

export class SetPatientTestResultInfo implements ReduxAction {
  type: string = "SET_PATIENT_TEST_RESULTS_INFO";
  testResultInfo: PatientTestResultsModel;

  constructor(params: PatientTestResultsModel) {
    this.testResultInfo = params;
  }

  get() {
    return this.testResultInfo;
  }
}



// WEBPACK FOOTER //
// /Users/maxsheikhizadeh/Desktop/GEN/physician-portal/src/app/shared/actions/patient-test-results.actions.ts